import type { CharacterStats } from '../types/character';
import {
  DEFAULT_CHARACTER_STATS,
  DEFAULT_CHARACTER_LEVEL,
  CHARACTER_LEVEL_MIN,
  CHARACTER_LEVEL_MAX,
} from '../types/character';

const MIN_STAT = 1;
const MAX_STAT = 10;

function clampStat(value: unknown): number {
  const n = typeof value === 'number' ? value : parseInt(String(value), 10);
  if (Number.isNaN(n)) return 5;
  return Math.min(MAX_STAT, Math.max(MIN_STAT, Math.round(n)));
}

/** Firestore 등에서 읽은 값을 안전한 CharacterStats로 정규화. 구 diligence/teamwork/creativity → atk/def/hp 매핑 */
export function normalizeCharacterStats(raw: unknown): CharacterStats {
  if (!raw || typeof raw !== 'object') {
    return { ...DEFAULT_CHARACTER_STATS };
  }
  const o = raw as Record<string, unknown>;
  return {
    atk: clampStat(o.atk ?? o.diligence),
    def: clampStat(o.def ?? o.teamwork),
    hp: clampStat(o.hp ?? o.creativity),
    mp: clampStat(o.mp),
  };
}

export { MIN_STAT as CHARACTER_STAT_MIN, MAX_STAT as CHARACTER_STAT_MAX };

export function normalizeCharacterLevel(raw: unknown): number {
  const n = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
  if (Number.isNaN(n)) return DEFAULT_CHARACTER_LEVEL;
  return Math.min(CHARACTER_LEVEL_MAX, Math.max(CHARACTER_LEVEL_MIN, Math.round(n)));
}

export { CHARACTER_LEVEL_MIN, CHARACTER_LEVEL_MAX };
